import { Pipe, PipeTransform } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, delay } from 'rxjs/operators';

import { LOOKUP, LookupModel, LookupService } from '@eightcap/core';

@Pipe({
    name: 'countryName',
    pure: false
})
export class CountryNamePipe implements PipeTransform {
    private static countries: LookupModel[] = [];
    private static countries$: Observable<LookupModel[]>;
    constructor(private readonly lookupService: LookupService) {
        if (!CountryNamePipe.countries$) {
            CountryNamePipe.countries$ = this.lookupService.lookup(LOOKUP.COUNTRY);
            CountryNamePipe.countries$
                .subscribe({
                    next: (countries) => {
                        CountryNamePipe.countries = countries || [];
                    }
                });
        }  
    }
    transform(countryCode: string): Observable<string> {
        if (CountryNamePipe.countries.length > 0) {
            return of(this.getCountryName(countryCode));
        }
        return of(null).pipe(
            // Wait 1 second in first time load country lookup
            delay(1000),
            map(() => this.getCountryName(countryCode))
        );
    }

    private getCountryName(countryCode: string): string {
        const findIndex = CountryNamePipe.countries.findIndex((country) => country.code === countryCode);
        return findIndex >= 0 ? CountryNamePipe.countries[findIndex].name || countryCode : countryCode;
    }
}
